<template>
  <div>
    <resource
      resource="user"
      :attributes="[
        {
          name: 'name',
          label: 'Name'
        },
        {
          name: 'email',
          label: 'Email'
        },
        {
          name: 'password',
          label: 'Password'
        },
        {
          name: 'roles',
          label: 'Rollen',
          type: 'RoleSelector'
        },
        {
          name: 'permissions',
          label: 'Berechtigungen',
          type: 'PermissionSelector'
        }
      ]"
    >
      <template v-slot:title>
        <h4>Systembenutzer Erstellen</h4>
      </template>
    </resource>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
